import { Context, Effect } from "effect";
import type { ResourceFailure } from "@workerstation/shared/errors/resource";
import type { KVBindingRecord, KVEntryPage, KVListOptions, KVTarget } from "./model.ts";

export interface KVApiShape {
  readonly bindings: (workspaceId: string) => Effect.Effect<readonly KVBindingRecord[], ResourceFailure>;
  readonly entries: (target: KVTarget, options?: KVListOptions) => Effect.Effect<KVEntryPage, ResourceFailure>;
  readonly read: (target: KVTarget, key: string) => Effect.Effect<string | null, ResourceFailure>;
  readonly write: (target: KVTarget, key: string, value: string) => Effect.Effect<void, ResourceFailure>;
  readonly delete: (target: KVTarget, key: string) => Effect.Effect<void, ResourceFailure>;
}
export class KVApi extends Context.Service<KVApi, KVApiShape>()("workerstation/frontend/KVApi") {}
